class LoopEndpoints {
    userPolicyDetails = (userId) => `/fetchUserPolicyDetails?userId=${userId}`;
    fetchDependentList = (employerId) => `/fetchDependentsForUserId?userId=${employerId}`;
    postEnrolmentData = () => '/scripts/skfEnrolment';
}
export default new LoopEndpoints();
